import { addInstallationServicesToShoppingCart, deleteSubItemFromMandy, } from '@coolblue-development/next-shopping-cart/actions';
export const addServiceToCart = async (itemId, productId, logger, accessoryId) => {
    try {
        return (await addInstallationServicesToShoppingCart({
            itemId,
            installationServices: [
                {
                    productId,
                    accessoryId: accessoryId ? accessoryId.toString() : undefined,
                },
            ],
        }));
    }
    catch (error) {
        logger.error('Error adding installation service to cart', error, {
            productId,
            itemId,
            package: 'next-installation-services',
        });
        return undefined;
    }
};
export const removeServiceFromCart = async (itemId, subItemId, logger) => {
    try {
        await deleteSubItemFromMandy({
            itemId,
            subItemId,
        });
    }
    catch (error) {
        logger.error('Error removing installation service from cart', error, {
            subItemId,
            itemId,
            package: 'next-installation-services',
        });
        return undefined;
    }
};
export const findSubItemId = (shoppingCartResponse, shoppingCartItemId, productId) => {
    var _a, _b;
    return (_b = (_a = shoppingCartResponse.data.shoppingCartItems
        .find(item => item.shoppingCartItemId === shoppingCartItemId)) === null || _a === void 0 ? void 0 : _a.subItems.find(subItem => subItem.product.productId === productId)) === null || _b === void 0 ? void 0 : _b.shoppingCartItemId;
};
//# sourceMappingURL=ShoppingCartHelpers.js.map